import { AxiosError } from 'axios';
import { api } from '@/Data/api';
import ss from '../Session';
import type { AdmissionProcess } from '@/Recoil/Admission/Process';
import type { AdmissionApiResponse } from './index';
import { getStoredLanguage } from '@/Components/LanguageSelector';

export interface ProcessParams {
    universityid: string;
    trackid: string;
    applicationid?: string;
}

/**
 * Get complete admission process with progress tracking
 * @param params ProcessParams with universityid and trackid (applicationid optional)
 * @returns Promise with admission process data or null
 */
export const getAdmissionProcessAPI = async (params: ProcessParams): Promise<AdmissionProcess | null> => {
    try {
        if (!params.universityid || !params.trackid) {
            throw new Error('University ID and Track ID are required');
        }

        const res = await api.get<AdmissionApiResponse<AdmissionProcess>>(
            '/admission/process',
            {
                params,
                headers: {
                    Authorization: `Bearer ${ss.getCurrentSession().jwt}`,
                    'Accept-Language': getStoredLanguage()
                }
            }
        );

        if (res.data?.code === 200) {
            return res.data.data;
        }

        return null;
    } catch (e) {
        if (e instanceof AxiosError && e.response?.status === 404) {
            console.warn('Admission process not found:', params);
            return null;
        }
        console.error('Failed to get admission process via API:', e);
        return null;
    }
};